module.exports = __webpack_public_path__ + "img/uv_2.4b5ac7d7.png";